import { __assign, __rest } from "tslib";
import React, { useCallback } from 'react';
import BiSpan from '@wix/da-bi/pkg/Components/BiSpan';
/**
 * A button made from a 'span'. For use in situations we need to nest buttons. Handles all the necessary events
 * to make it just like a real button
 */
var FakeButton = function (_a) {
    var _b = _a.onClick, onClick = _b === void 0 ? function () { return null; } : _b, _c = _a.onKeyDown, onKeyDown = _c === void 0 ? function () { return null; } : _c, props = __rest(_a, ["onClick", "onKeyDown"]);
    /**
     * Our fake button is mostly used in contexts where we need to nest a button inside of another button.
     *
     * Due to event propagation, keydown events trigger the fake button's click and the real button's click.
     * We don't want that.
     */
    var handleKeyDownForFakeButton = useCallback(function (e) {
        switch (e.key) {
            case ' ':
            case 'Space':
            case 'Enter':
                onClick(e);
                e.stopPropagation();
                break;
            default:
                break;
        }
        onKeyDown(e);
    }, [onKeyDown, onClick]);
    return (React.createElement(BiSpan, __assign({ tabIndex: 0, role: "button", onClick: onClick, onKeyDown: handleKeyDownForFakeButton }, props)));
};
FakeButton.displayName = 'FakeButton';
export default FakeButton;
//# sourceMappingURL=FakeButton.js.map